import type { BuilderTab } from "./types";

export function BuilderTabs({
  active,
  hooksCount,
  submissionsCount,
  showSubmissions,
  isYandex,
  onChange,
}: {
  active: BuilderTab;
  hooksCount: number;
  submissionsCount?: number;
  showSubmissions: boolean;
  isYandex?: boolean;
  onChange: (tab: BuilderTab) => void;
}) {
  const tabs: Array<{ id: BuilderTab; label: string; badge?: number }> = [
    { id: "form", label: isYandex ? "Вопросы" : "Конструктор" },
  ];

  if (!isYandex) {
    tabs.push(
      { id: "appearance", label: "Оформление" },
      { id: "hooks", label: "Webhooks", badge: hooksCount || undefined },
    );
  }

  if (showSubmissions) {
    tabs.push({
      id: "submissions",
      label: "Ответы",
      badge: submissionsCount || undefined,
    });
  }

  tabs.push({ id: "settings", label: "Настройки" });

  return (
    <div
      role="tablist"
      aria-label="Разделы редактора формы"
      className="flex gap-1 rounded-lg border border-slate-200 bg-slate-50/80 p-1"
    >
      {tabs.map((tab) => {
        const selected = active === tab.id;
        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={selected}
            onClick={() => onChange(tab.id)}
            className={[
              "inline-flex items-center gap-1.5 rounded-md px-3 py-1.5 font-onest text-sm font-medium transition-colors",
              selected
                ? "bg-white text-ink shadow-sm"
                : "text-slate-600 hover:text-slate-900",
            ].join(" ")}
          >
            {tab.label}
            {tab.badge != null && tab.badge > 0 ? (
              <span className="rounded-full bg-brand-100 px-1.5 py-px font-onest text-[10px] font-semibold text-brand-700">
                {tab.badge}
              </span>
            ) : null}
          </button>
        );
      })}
    </div>
  );
}
